import React from 'react';

const CoverPage = ({ displayData }) => (
  <div className="bg-slate-800 dark:bg-slate-900 text-white p-8 rounded-lg min-h-[600px] flex flex-col justify-between">
    <div>
      <div className="mb-8">
        <h1 className="text-4xl font-bold text-emerald-400 dark:text-emerald-300 mb-2">
          RELY ABILITY
        </h1>
        <p className="text-lg text-gray-300 dark:text-gray-400">
          Energy Productivity Solutions
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-3xl font-bold mb-4">Energy Savings Assessment</h2>
        <h3 className="text-xl text-emerald-300 dark:text-emerald-400 mb-6">
          Detailed Report
        </h3>

        <div className="space-y-2 text-lg">
          <p>
            <span className="font-semibold">Facility:</span> Professional Baking
            Facility (Demo)
          </p>
          <p>
            <span className="font-semibold">Analysis Type:</span>{' '}
            {displayData.isRealAnalysis
              ? 'Live Professional Analysis'
              : 'Sample Demonstration'}
          </p>
          <p>
            <span className="font-semibold">Methodology:</span>{' '}
            {displayData.methodology}
          </p>
          <p>
            <span className="font-semibold">Engine:</span>{' '}
            {displayData.engineVersion}
          </p>
        </div>
      </div>
    </div>

    <div className="space-y-4">
      <div className="bg-emerald-600 dark:bg-emerald-500 p-4 rounded-lg text-center">
        <p className="text-2xl font-bold">✓ Complete Professional Analysis</p>
      </div>

      <div
        className={`p-4 rounded-lg text-center ${
          displayData.isRealAnalysis
            ? 'bg-emerald-700 dark:bg-emerald-600'
            : 'bg-slate-700 dark:bg-slate-800'
        }`}
      >
        <p className="text-sm text-gray-300 dark:text-gray-100">
          {displayData.isRealAnalysis
            ? '✅ This report shows REAL analysis methodology with professional calculations - Full access provided'
            : 'This sample report demonstrates our comprehensive methodology and professional analysis capabilities.'}
        </p>
      </div>
    </div>
  </div>
);

export default CoverPage;


